import { createContext } from 'react';

const initialState = [];
export const WeatherStartContext = createContext(initialState);